import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MedicalCards } from "./medical-cards";
import { Profile } from "./profile";
import { Timetable } from "./timetable";
import { Loader } from "../../components/Loader";
import { AccountRole, useAccountQuery, useMeQuery } from "../../graphql";

export const PatientBox: React.FC<{ clientId: number; silent?: boolean }> = ({
    clientId,
    silent = false
}) => {
    const { t } = useTranslation();
    const { data, loading } = useAccountQuery({
        variables: {
            id: clientId
        }
    });

    if (loading) {
        return <Loader />;
    }

    if (data.account.role === AccountRole.Client) {
        return (
            <Tabs>
                <TabList>
                    <Tab>{ t("account.profile") }</Tab>
                    <Tab>{ t("account.medicalCard") }</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <Profile clientId={ clientId } silent={ silent } />
                    </TabPanel>
                    <TabPanel>
                        <MedicalCards clientId={ clientId } silent={ silent } />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        );
    }

    return (
        <Tabs>
            <TabList>
                <Tab>Profili</Tab>
                <Tab>Orari</Tab>
            </TabList>

            <TabPanels>
                <TabPanel>
                    <Profile clientId={ clientId } silent={ silent } />
                </TabPanel>
                <TabPanel>
                    <Timetable clientId={ clientId } silent={ silent } />
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
};
